import React from 'react';
import { Pressable, Text, StyleSheet, ActivityIndicator, View, StyleProp, ViewStyle, PressableProps } from 'react-native';
import { colors, fonts, radii, spacing } from '../theme';

type Variant = 'solid' | 'line' | 'ghost' | 'danger';

type Props = Omit<PressableProps, 'style'> & {
  title: string;
  onPress?: (event: any) => void;
  variant?: Variant;
  disabled?: boolean;
  loading?: boolean;
  style?: StyleProp<ViewStyle>;
};

// Substitui o <Button> nativo (cinza/azul de plataforma).
// forwardRef: preserva ref para compatibilidade total.
export const Button = React.forwardRef<View, Props>(function Button(
  { title, onPress, variant = 'solid', disabled, loading, style, ...restProps },
  ref
) {
  return (
    <Pressable
      ref={ref}
      onPress={onPress}
      disabled={disabled || loading}
      style={({ pressed }) => [
        styles.base,
        variantStyles[variant],
        pressed && !disabled && styles.pressed,
        disabled && styles.disabled,
        style,
      ]}
      {...restProps}
    >
      {loading ? (
        <ActivityIndicator color={variant === 'solid' ? colors.onSage : labelVariantStyles[variant].color} />
      ) : (
        <Text style={[styles.label, labelVariantStyles[variant]]}>{title}</Text>
      )}
    </Pressable>
  );
});

const styles = StyleSheet.create({
  base: {
    borderRadius: radii.pill,
    paddingVertical: 14,
    paddingHorizontal: spacing.lg,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing.sm,
  },
  pressed: { opacity: 0.85 },
  disabled: { opacity: 0.5 },
  label: { fontFamily: fonts.bodyBold, fontSize: 15 },
});

const variantStyles = StyleSheet.create({
  solid: { backgroundColor: colors.sageDeep },
  line: { borderWidth: 2, borderColor: colors.sageDeep, backgroundColor: 'transparent' },
  ghost: { backgroundColor: 'transparent', paddingVertical: 8 },
  danger: { borderWidth: 2, borderColor: colors.clay, backgroundColor: 'transparent' },
});

const labelVariantStyles = StyleSheet.create({
  solid: { color: colors.onSage },
  line: { color: colors.sageDeep },
  ghost: { color: colors.thread, fontFamily: fonts.bodyMedium },
  danger: { color: colors.clay },
});
